const envs = {
  apiBaseUrl: process.env.REACT_APP_SERVER,
  beneUri: process.env.REACT_APP_BENE_URI,
  ws: process.env.REACT_APP_WS,
  streamerUri: process.env.REACT_APP_STREAMER_APP,
};

export default envs;
